export default {
      id: "i-h-menu-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-h-menu",
      toString: function () {
        return this.url;
      }
    }